/* eslint-disable */
import Vue from 'vue'
import {
  SET_COURSES,
  SET_COURSE_WRAPPER,
  SET_PAY_INFO,
  // SET_ORDER,

  SET_LOGIN_SOURCE,
  SET_PHONE,
  SET_TOKEN,
} from './mutation-types'

import { removeToken, removeMerchantName } from '@/common/auth'

export default {

  [SET_COURSES] (state, {courses}) {
    state.courses = courses
  },

  [SET_COURSE_WRAPPER] (state, {courseWrapper}) {
    state.courseWrapper = courseWrapper
  },

  [SET_PAY_INFO] (state, {payInfo}) {
    state.payInfo = payInfo
  },

  // [SET_ORDER] (state, {order}) {
  //   state.order = order
  // },


  [SET_LOGIN_SOURCE] (state, {loginSource}) {
    state.loginSource = loginSource
  },

  /**
   * 设置登录手机号码
   * @param state
   * @param phone
   */
  [SET_PHONE] (state, {phone}) {
    state.phone = phone
  },

  /**
   * 设置Token
   * @param state
   * @param loginPhone
   */
  [SET_TOKEN] (state, {token}) {
    state.token = token
  },

}



// WEBPACK FOOTER //
// ./src/store/mutations.js